//import SmoothScroll from 'smooth-scroll';
export class More {
    constructor() {
        this.showContents = {};
        this.btn = {};
        this.hasShowMore = false;
        this.scroll = {};
    }

    getStyle(e, styleName) {
        var styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        } else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return styleValue.replace(/px/g, '');
    }

    init() {
        //console.log('More init');
        if (document.getElementById('js-casestudy-more')) {
            this.hasShowMore = true;
            this.btn = document.getElementById('js-casestudy-more-btn');
            this.btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.showMore(6);
            });
        }
    }

    showMore(num) {
        // 表示できる要素の残り
        this.showContents = document.querySelectorAll('.col.hide');

        // 残りをチェックして、今回の表示で残りがなくなる場合はボタン非表示
        if (this.showContents.length <= 6) {
            this.btn.classList.add('hide');
        }

        // 6個ずつ表示
        let maxNum = Math.min(this.showContents.length, 6);
        for (var i = 0; i <= (maxNum - 1); i++) {
            // console.log(i);
            this.showContents[i].classList.add('to-show');
            this.showContents[i].classList.remove('hide');

            let delaytime = 60 + (30 * i);
            let myNum = i;
            window.setTimeout(() => {
                //console.log(myNum);
                this.showContents[myNum].classList.remove('to-show');
                this.showContents[myNum].classList.add('js-anim-inview');
                this.showContents[myNum].classList.add('fadein');
                this.showContents[myNum].classList.add('inview');
            }, delaytime);
        }





    }


}